const PILL_HEIGHT = 20;
const PILL_PADDING = 10;
const PILL_ROW_GAP = 8;
const PILL_X_MIN = -10;
const SHOW_MORE_BUTTON_OFFSET = 27;
const ANNOTATION_Y_AXIS_LABEL_HEIGHT = 11.5;

export { ANNOTATION_Y_AXIS_LABEL_HEIGHT, PILL_HEIGHT, PILL_PADDING, PILL_ROW_GAP, PILL_X_MIN, SHOW_MORE_BUTTON_OFFSET };
